import { normalize, schema } from 'normalizr';

import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'terminal';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'terminalID',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);

// Terminal Transformer
export const { transformer, listTransformer } = createRetailTransformers('terminal');
